module.exports = __webpack_public_path__ + "static/img/whiteLogo.a0137684.png";